import { render } from '@wordpress/element';

import './components/settings.scss';
import Header from './components/header';
import Tabs from './components/tabs';
const Settings = ( props ) => {
	return (
		<div className="re-esp-settings-wrap">
			<Header />
			<Tabs />
		</div>
	);
};

var rootElement = document.getElementById( 're-esp-settings' );

if ( rootElement ) {
	render( <Settings scope="global" />, rootElement );
}
